import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Introduction`}</h2>
    <p>{`Ready to bring the engaging power of GIFs to your app through GIPHY?`}</p>
    <p>{`By integrating with GIPHY, the first and largest GIF search engine, you gain free access to our ever-growing content library of GIFs and `}<a href="/docs/sdk/#content-types">{`Stickers`}</a>{` — featuring the latest in entertainment, sports, and breaking news from GIPHY's official content partners.`}</p>
    <p>{`All of our content is searchable in over `}<a href="/docs/optional-settings#language-support">{`thirty languages`}</a>{` and is available in various sizes so you get the highest quality images at the lowest file sizes. Plus, there's all the classic reaction GIFs you'll ever need.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      